// extracted by mini-css-extract-plugin
export default {"informationDetailsContent":"informationDetails_informationDetailsContent__itULy","informationDetails":"informationDetails_informationDetails__O0mhX"};